import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../services/api';
import './SystemStatusBar.css';

function formatDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit' });
}

export default function SystemStatusBar() {
  const [systemDate, setSystemDate] = useState('');
  const [realDate, setRealDate] = useState('');
  const [username, setUsername] = useState('');

  // Function to update username from localStorage
  const updateUsername = () => {
    try {
      const userStr = localStorage.getItem('user');
      if (userStr) {
        const user = JSON.parse(userStr);
        // Try multiple possible fields for username
        const foundUsername = user.username || user.name || user.userName || '';
        if (foundUsername) {
          setUsername(foundUsername);
        } else {
          // Debug: log the user object to see what fields are available
          console.log('User object from localStorage:', user);
        }
      }
    } catch (e) {
      console.error('Error reading user from localStorage:', e);
    }
  };

  useEffect(() => {
    // Fetch system date from backend
    axios.get(`${API_BASE_URL}/system-day`)
      .then(res => {
        if (res.data && res.data.system_day) {
          setSystemDate(res.data.system_day);
        }
      })
      .catch(() => setSystemDate('Error'));
    // Set real date from client
    const now = new Date();
    setRealDate(formatDate(now));
    
    // Get logged-in username from localStorage
    updateUsername();
    
    // Also listen for storage changes (in case user logs in/out in another tab)
    const handleStorageChange = () => {
      updateUsername();
    };
    
    window.addEventListener('storage', handleStorageChange);
    
    // Listen for custom login event (dispatched from LoginPage)
    const handleLoginEvent = () => {
      updateUsername();
    };
    
    window.addEventListener('userLoggedIn', handleLoginEvent);
    
    // Also check periodically in case localStorage was updated in the same tab (but less frequently)
    const interval = setInterval(() => {
      updateUsername();
    }, 2000); // Check every 2 seconds
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('userLoggedIn', handleLoginEvent);
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="system-status-bar">
      {username && (
        <span>
          <strong>User:</strong> {username}
        </span>
      )}
      <span>
        <strong>System Date:</strong> {systemDate ? formatDate(systemDate) : 'Loading...'}
      </span>
      <span>
        <strong>Real Date:</strong> {realDate || 'Loading...'}
      </span>
    </div>
  );
}
